<template>
  <div>
    <!-- <v-text-field
      :value="precios"
      label="Precios del periodo"
      prepend-icon="mdi-currency-usd"
      color="primary"
    ></v-text-field> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'PreciosSelectedComponent',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Number,
    fecha: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      precios: null
    }
  },
  computed: {
    precioId: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('change', value)
      }
    }
  },
  watch: {
    fecha (newValue) {
      if (newValue) {
        this.onVigente(newValue).then(response => {
          this.precios = 'Subsidio: $ ' + response.subsidio + '; Usuario: $ ' + response.usuario + '; Pleno: $ ' + response.pleno
          this.precioId = response.id
        })
      }
      else {
        this.precios = null
        this.precioId = null
      }
    }
  },
  methods: {
    ...mapActions('PreciosVigentes', ['onVigente']),
  }
}
</script>
